<template>
  <div>
    <p class="text-left" v-if="cargando && tipo == 1">Espere mientras se carga la lista de proveedores...</p>
    <div v-else>
      <div class="card">
        <img 
          :src="`${UrlImgDrive}${config.logotipo}`" 
          :alt="`Logo ${empresa.nombre}`"
          class="card-img-top" 
        >
        <div class="row">
          <div class="col-sm-6">
            <div class="card-body">
              <h5 class="card-title">{{ empresa.nombre }}</h5>
              <p class="card-text">{{ config.bazar_texto }}</p>
            </div>
          </div>
          <div class="col-sm-6 text-sm-right mb-2 px-4">
            <template v-if="cat.redes_bazar">
              <a 
                v-for="(r, idx) in cat.redes_bazar" 
                :key="idx" 
                :href="r.enlace + r.cuenta" 
                :title="r.nombre"
                target="_blank"
              >
                <span 
                  class="badge badge-secondary red-social-bazar"
                  :style="{'background': r.color}"
                >
                  <i :class="r.icono"></i>
                </span>
              </a>
            </template>
          </div>
        </div>
      </div>
      <form @submit.prevent="buscar(2)">
        <div class="row mt-3">
          <div class="col-12">
            <div class="input-group mb-3">
              <input 
                type="search" 
                class="form-control" 
                placeholder="Nombre de la categoria" 
                aria-describedby="btn-buscar"
                v-model="termino"
              >
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="submit" id="btn-buscar" :disabled="cargando">
                  {{ cargando ? 'Buscando...' : 'Buscar'}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="row mt-2 mb-5" v-if="lista.length == 0 && !cargando">
        <div class="col-sm-12">
          <p class="alert alert-info">No se encontraron resultados</p>
        </div>
      </div>
      <div class="row row-cols-1 row-cols-md-3" v-else>
        <template v-for="r in filtrada">
          <div class="col mb-4" v-if="r.padre.bazar == 1" :key="r.padre.id">
            <div class="card h-100 mb-3">
              <div class="row no-gutters">
                <div class="col-md-4">
                  <img 
                    :src="`${UrlImgDrive}${r.padre.logo}`" 
                    class="card-img align-middle" 
                    :alt="`Logo ${r.padre.descripcion}`"
                    v-if="r.padre.logo"
                  >
                </div>
                <div class="col-md-8">
                  <div class="card-body">
                    <h5 class="card-title">
                      {{ r.padre.descripcion }}
                      <template v-if="r.redes">
                        <a 
                          v-for="(red, idx) in r.redes" 
                          :key="idx" 
                          :href="red.enlace + red.cuenta" 
                          :title="red.nombre"
                          target="_blank"
                        >
                          <span 
                            class="badge badge-secondary red-social-prov"
                            :style="{'background': red.color}"
                          >
                            <i :class="red.icono"></i>
                          </span>
                        </a>
                      </template>
                    </h5>
                    <p class="card-text">{{ r.padre.texto }}</p>
                    <p class="card-text align-bottom">
                      <a 
                        v-if="r.padre.externo == 1"
                        :href="r.padre.enlace" 
                        class="btn btn-primary btn-sm"
                        target="_blank" 
                      >Visitar</a>
                      <button 
                        v-else 
                        class="btn btn-sm btn-primary" 
                        @click="actualizaDatos(r)"
                      >
                        Ver
                      </button>
                      <button 
                        v-if="r.padre.externo == 1" 
                        class="btn btn-sm btn-warning ml-1" 
                        @click="setCompra(r.padre)"
                      > 
                        <i class="fa fa-plus"></i> Compra
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div class="modal fade" id="mdlCompra" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="staticBackdropLabel">Compra</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div v-if="mensaje !== null" class="text-center alert" :class="exito == 1 ? 'alert-info' : 'alert-danger'">{{ mensaje }}</div>
              <form @submit.prevent="guardarCompra">
                <div class="row form-group mb-2">
                  <div class="col-sm-12">
                    <label for="inputNotas">Descripción del producto:</label>
                    <textarea v-model="fcompra.notas" id="inputNotas" class="form-control border border-primary rounded-0"></textarea>
                  </div>
                </div>
                <div class="row form-group mb-2">
                  <div class="col-sm-6">
                    <label for="inputCantidad">Cantidad:</label>
                    <input type="number" id="inputCantidad" class="form-control border border-primary rounded-0" v-model="fcompra.cantidad">
                  </div>
                  <div class="col-sm-6">
                    <label for="inputPrecio">Precio:</label>
                    <input type="number" step="0.01" id="inputPrecio" class="form-control border border-primary rounded-0" v-model="fcompra.precio">
                  </div>
                </div>
                <div class="row form-group mb-2">
                  <div class="col-sm-6">
                    <label for="inputTelefono">Teléfono de contacto:</label>
                    <input type="text" id="inputTelefono" class="form-control border border-primary rounded-0" v-model="fcompra.telefono_contacto">
                  </div>
                  <div class="col-sm-6">
                    <label for="selectDirecciones">Direcciones sugeridas:</label>
                    <select id="selectDirecciones" class="custom-select border border-primary rounded-0" v-model="fcompra.direccion_sugerida">
                      <option value="">Seleccione una dirección</option>
                      <option :value="dir" v-for="(dir, i) in cat.direcciones" :key="i">{{ dir }}</option>
                      <option value="-1">Otro</option>
                    </select>
                  </div>
                </div>
                <div class="row form-group mb-2" v-if="fcompra.direccion_sugerida == -1">
                  <div class="col-sm-12">
                    <label for="inputDireccion">Dirección de entrega:</label>
                    <input type="text" id="inputDireccion" class="form-control border-primary rounded-0" v-model="fcompra.direccion_entrega" placeholder="Dirección personalizada">
                  </div>
                </div>
                <table class="table table-sm">
                  <tbody>
                    <tr>
                      <th scope="row">TOTAL</th>
                      <th class="text-right">Q. {{ totalCompra }}</th>
                    </tr>
                  </tbody>
                </table>
                <div class="row form-group mb-2">
                  <div class="col-sm-12">
                    <label for="inputNotas">Comentario:</label>
                    <textarea v-model="fcompra.comentario" id="inputNotas" class="form-control border border-primary rounded-0"></textarea>
                  </div>
                </div>
                <div class="form-group col-md-12 text-right mb-2">
                  <button 
                    type="button" 
                    class="btn btn-warning mr-2 rounded-pill shadow-sm px-4" 
                    data-dismiss="modal"
                    v-if="!btnGuardar"
                  ><i class="fa fa-times"></i> Cancelar</button>
                  <button 
                    type="submit" 
                    class="btn btn-primary rounded-pill shadow-sm px-4" 
                    :disabled="btnGuardar"
                  >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    v-if="btnGuardar"
                  ></span>
                    <span v-else><i class="fa fa-save"></i> Guardar</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import $ from 'jquery';

  export default {
    name: 'BazarProveedor',
    props: {
      emp: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      btnGuardar: false,
      config: {},
      empresa: {},
      lista: [],
      termino: '',
      cargando: true,
      buscando: true,
      tipo: 1,
      fcompra: {},
      tmpProv: null,
      mensaje: null,
      cat: {
        direcciones: [],
        redes_bazar: [],
        redes_proveedor: []
      },
    }),
    created() {
      this.getDatos();
      this.buscar();
      this.getRedes();
    },
    methods: {
      buscar (tipo) {
        if (tipo) this.tipo = tipo;
        this.cargando = true
        axios
        .get(this.UrlBase+'/bazar/get_proveedores', {params:{
          dominio:this.emp.dominio,
          descripcion: this.termino
        }}).then(res => {
          this.config = res.data.config;
          this.empresa = res.data.empresa;
          this.lista = res.data.lista;
          this.cargando = false
        }).catch(e => {
          alert("Cat "+e);
          this.cargando = false
        });
      },
      actualizaDatos (valor) {
        this.$emit('setProveedor',{
          prov: valor,
          config: this.config
        });
      },
      setCompra (valor) {
        this.fcompra = {
          direccion_sugerida: ''
        };
        this.tmpProv = valor;
        $("#mdlCompra").modal();
      },
      guardarCompra () {
        if (confirm('¿Está seguro?')) {
          this.mensaje = null;

          this.btnGuardar = true;
          let header = JSON.parse(localStorage.getItem(`bazar_${this.emp.dominio}`))

          axios.defaults.headers = {
            Authorization: header.token
          }
          this.fcompra.proveedor = this.tmpProv.id;

          axios
          .post(this.UrlBase+'/bazar/guardar_compra_externa', this.fcompra)
          .then(res => {
            this.mensaje = res.data.mensaje;
            this.exito = res.data.exito;
            if (res.data.exito) {
              this.fcompra = {};
              this.$emit('actSaldo',res.data.saldo);
            }
            this.btnGuardar = false;
          }).catch(e => {
            this.btnGuardar = false;
            alert('Compra '+e);
          })
        }
      },
      getDatos() {
        axios
          .get(this.UrlBase+'/bazar/get_direcciones')
          .then(res => {
            this.cat.direcciones = res.data
          }).catch(e => {
            this.btnGuardar = false;
            alert('Datos '+e);
          })
      },
      getRedes() {
        axios
          .get(this.UrlBase+'/bazar/get_redes')
          .then(res => {
            this.cat.redes_bazar = res.data.redes_bazar
            this.cat.redes_proveedor = res.data.redes_proveedor
            console.log(this.getRedesProveedor(435))
          }).catch(e => {
            this.btnGuardar = false;
            alert('Redes '+e);
          })
      },
      getRedesProveedor(categoria) {
        return this.cat.redes_proveedor.filter(r => r.carta_categoria_id == categoria)
      }
    },
    computed: {
      filtrada () {
        return this.lista.filter(o => {
          return o.padre.bazar == 1 && o.padre.descripcion.toLowerCase().includes(this.termino)
        }).map(o => {
          o.redes = this.cat.redes_proveedor.filter(r => r.carta_categoria_id == o.padre.id)

          return o
        });
      },
      totalCompra () {
        if (this.fcompra.cantidad && this.fcompra.precio) {
          return parseFloat(this.fcompra.cantidad*this.fcompra.precio).toFixed(2);
        }

        return 0;
      }
    },
    watch: {
      'fcompra.direccion_sugerida'(direccion) {
        this.fcompra.direccion_entrega = ''
        if (direccion != -1) {
          this.fcompra.direccion_entrega = direccion
        }
      }
    }
  }
</script>

<style>
  .imgProveedor {
    height:500px;
  }

  @media only screen and (max-width: 600px) {
    .imgProveedor {
      height:150px;
    }
  }

  .red-social-bazar {
    font-size: 1.1em;
    padding: 10px;
    border-radius: 50%;
    margin: 0 1.5px;
  }
  .red-social-prov {
    float: right;
    padding: 7.5px;
    border-radius: 50%;
    margin: 0 1.5px;
  }
</style>